import { site } from '@/content/site'

/** Canonical base URL for SEO — prefers VITE_SITE_URL, falls back to site.websiteUrl. */
export function getSiteUrl(): string {
  return import.meta.env.VITE_SITE_URL?.replace(/\/$/, '') || site.websiteUrl
}
